import React, { useEffect } from 'react' ;
import "./extractMorePosts.css" ; 
import ListPosts from '../../Components/Utils/ListPosts';
import { STATUS } from '../../Constants';
import { useDispatch, useSelector } from 'react-redux';
import { getSavedPosts, restPosts } from '../../RTK/Slice/GroupData/CollectSlice';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ExtractMorePostsPage = () => {

  // For Translate Page 
  const {t} = useTranslation() ; 

    // For Dispatch Action
    const dispatch = useDispatch() ;

    // For Get Saved Posts 
    const posts = useSelector(getSavedPosts) ; 

    // For Clear All Saved Post 
    const clearSavedPostsHandler = ()=>{
      dispatch(restPosts()) ; 
    }

  useEffect(()=>{
    window.onbeforeunload = function(){
      window.alert("BeCarefull")
    }
  } , [])


  return (
    <section className='extrac-more-post' >
        
        {posts.length > 0 ? (<button className='clear-posts' onClick={clearSavedPostsHandler}>{t('clearPosts')} </button>) :""}
        {posts.length > 0 ? (<Link style={{textDecoration :"none" , margin : "0px 12px"}} to={"/extractdata/search/extractCommentsFromMorePost"}><button className='clear-posts' >{t('extractComments')} </button></Link>) :""}
        
        
        <ListPosts selectAllOption={false} hideAddPost={true} posts={posts} status={STATUS.SUCCESS} />
    </section>
  )
}

export default ExtractMorePostsPage
